export enum RecruiterUpdateFields {
  AVATAR = 'avatar',
  FULL_NAME = 'fullName',
  PHONE_NUMBER = 'phoneNumber',
  POSITION_TITLE = 'positionTitle',
}
